<template>
  <div class="banner1 black">  
    <div class="f1-ns center tc f2 b pt4 ph2">We carry the brands you trust</div>
    <div class="f2-ns f3 b tc mt5-ns">
      <Carousel v-if="images.length !== 0" class="mt4" :pics="images" :perPageCount="mobile ? mobileSlides : desktopSlides" :fast="2000" :scrollPerPage="false"/>
    </div>
  </div>
</template>

<script>
import Parallax from 'vue-parallaxy'
import Carousel from '@/components/Carousel'
export default {
  name: 'Trust',
  props: ['info', 'mobile'],
    data() {
    return {
      current_img: 0,
      position: null,
      images: [
      ],
      load: false,
      mobileSlides: 1,
      desktopSlides: 4
    };
  },
  methods: {
    importAll(r) {
      r.keys().forEach(key => (this.images.push({ pathLong: r(key), pathShort: key })));
    },
    handleScroll (e) {
      this.position = window.scrollY
    },
    next: function() {
      this.current_img += 1;
    },
    prev: function() {
      this.current_img -= 1;
      if (this.current_img < 0) {
        this.current_img = (this.images.length - 1);
      }
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);

  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted() {
    this.importAll(require.context('../../assets/logos-color/', true, /\.jpg$/));
    this.importAll(require.context('../../assets/logos-color/', true, /\.png$/));
    this.load = true
  },
  components: { Carousel, Parallax }
}
</script>

<style scoped>
.banner1 {
  height: 100%;
  min-height: 35vh;
  background: #F7F7F9;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

.products-button, .contact-button {
  box-shadow: #0f376f 5px 5px;
  color: rgb(15,55,111) 5px 5px;
  opacity: .9;
}

.products-button:hover {
  opacity: 1;
  background: rgb(15,55,111);
  box-shadow:gold 5px 5px;
  color: gold;
  transition: .3s ease;
}
</style>